module.exports = __webpack_public_path__ + "img/32.e58d8a96.png";